import { Button } from 'react-bootstrap';
import { contactInfo } from '../../config/contactInfo';

interface ScheduleButtonProps {
  isBanner: boolean;
  size?: 'lg';
}

function ScheduleButton({ isBanner, size = 'lg' }: ScheduleButtonProps) {
  return (
    <Button variant="outline-primary" 
            size={size}
            className={isBanner ? "button-schedule-banner" : "button-schedule-location"}
            href={contactInfo.whatsappScheduleUrl}>
      Agende sua consulta
    </Button>
  );
}

export default ScheduleButton;
